import { render, staticRenderFns } from "./PlanChangeSettings.vue?vue&type=template&id=f19dd65c&"
import script from "./PlanChangeSettings.vue?vue&type=script&lang=js&"
export * from "./PlanChangeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports